import { Feature, Point } from 'geojson';
// 链接localStorage中原始点数据的加载器
import Schema from 'schema.io';
import { LS_ORIGINAL_POINTS_KEY } from '../../utils/constants';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';

const lngLatsSchema = new Schema([{
  lngLat: [Number],
  properties: Object,
}]);

export interface IOriginalPoint {
  lngLat: ILngLat;
  properties: IObject;
}

export default class OriginalPointsLoader extends SingletonEventEmitterClass {
  private static _readFromLocalStorage() {
    const data = localStorage.getItem(LS_ORIGINAL_POINTS_KEY);
    if (data) {
      try {
        const points = JSON.parse(data);
        lngLatsSchema.validate(points);
        return points as IOriginalPoint[];
      } catch (e) {
        return [];
      }
    } else {
      return [];
    }
  }

  private _points?: IOriginalPoint[];

  public get geojson(): GeoJSON.FeatureCollection<Point> {
    return {
      type: 'FeatureCollection',
      features: this._points!.map<Feature<Point>>(point => {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: point.lngLat,
          },
          properties: point.properties,
        };
      }),
    };
  }

  constructor() {
    super();
    if (OriginalPointsLoader.__new) {
      this._points = OriginalPointsLoader._readFromLocalStorage();
    }
  }

  public addPoints(points: IOriginalPoint[]) {
    points.forEach(point => {
      if (!this._points!.find(p => p.lngLat.toString() === point.lngLat.toString())) {
        this._points!.push(point);
      }
    });
    localStorage.setItem(LS_ORIGINAL_POINTS_KEY, JSON.stringify(this._points));
    this._triggerRefresh();
  }

  public clear() {
    this._points = [];
    localStorage.removeItem(LS_ORIGINAL_POINTS_KEY);
    this._triggerRefresh();
  }

  private _triggerRefresh() {
    this.emit('updated');
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/OriginalPointsLoader.ts